import type { Catalog } from "@/lib/i18n/en";

export const ar: Catalog = {
  "app.tagline": "اجتماعات تبدأ بنقرة واحدة.",
  "app.poweredBy": "مدعوم من BS Group",
  "app.madeIn": "صُنع بـ {heart} في بلجيكا",
  "nav.meetings": "الاجتماعات",
  "nav.rooms": "الغرف",
  "nav.signIn": "تسجيل الدخول",
  "nav.signOut": "تسجيل الخروج",
  "nav.createAccount": "إنشاء حساب",
  "nav.settings": "الإعدادات",
  "nav.docs": "التوثيق",
  "nav.privacy": "الخصوصية",
  "privacy.title": "{name} Privacy Policy",
  "privacy.description": "How {name} handles personal data, meeting content and recordings.",
  "nav.language": "اللغة",
  "nav.theme": "المظهر: {theme}. التبديل إلى {next}",
  "theme.system": "النظام",
  "theme.light": "فاتح",
  "theme.dark": "داكن",

  "common.cancel": "إلغاء",
  "common.confirm": "تأكيد",
  "common.save": "حفظ",
  "common.done": "تم",
  "common.close": "إغلاق",
  "common.edit": "تعديل",
  "common.join": "انضمام",
  "common.loading": "جارٍ التحميل",
  "common.somethingWentWrong": "حدث خطأ ما",
  "common.you": "أنت",
  "common.copied": "تم النسخ",
  "common.search": "بحث",
  "common.noMatches": "لا توجد نتائج",

  "landing.intro":
    "{name} مكالمات مرئية لمن يريد أن يتحدث فحسب: شارك رمزًا، شارك شاشتك، ارسم على شريحة، وامضِ في عملك.",
  "landing.startMeeting": "ابدأ اجتماعًا",
  "landing.goToMeetings": "اذهب إلى اجتماعاتك",
  "landing.codePlaceholder": "abcd-efgh-ijkl",
  "landing.meetingCode": "رمز الاجتماع",
  "landing.feature.guests.title": "الضيوف ينضمون باسم فقط",
  "landing.feature.guests.body":
    "بلا حساب وبلا تثبيت. من يملك الرابط يكتب اسمًا فيدخل، بصوت وصورة كاملين.",
  "landing.feature.screen.title": "مشاركة شاشة تبقى مقروءة",
  "landing.feature.screen.body":
    "تُرسل الشاشة بدقتها الكاملة وتُعرض كاملة بدل أن تُقتطع، فيبقى النص واضحًا.",
  "landing.feature.board.title": "شرائح ولوح أبيض",
  "landing.feature.board.body":
    "ارفع ملف PDF أو PowerPoint فيتحول إلى شرائح يرسم عليها الجميع معًا داخل المكالمة.",
  "landing.feature.scale.title": "غرف كبيرة واجتماعات طويلة",
  "landing.feature.scale.body":
    "حتى 500 شخص في اجتماع واحد، ويمكن أن يستمر الاجتماع عشرين ساعة. لا مقاعد تُحسب، ولا انقطاع بعد أربعين دقيقة.",
  "landing.feature.record.title": "تسجيل يبدأ من تلقاء نفسه",
  "landing.feature.record.body":
    "فعّله للغرفة فيبدأ تسجيل كل اجتماع فيها مع أول من يدخل. لا أحد مضطر لأن يتذكر، والتسجيل يُشاهَد بعدها في المتصفح.",
  "landing.feature.control.title": "المضيف يبقى مسيطرًا",
  "landing.feature.control.body":
    "غرفة انتظار، أدوار لكل شخص، كتم، إزالة، وإنهاء للجميع ينهيه فعلًا.",
  "landing.badge": "الانضمام لا يحتاج حسابًا",
  "landing.joinTitle": "معك رمز؟",
  "landing.joinHint": "الصق الرابط الذي وصلك، أو اكتب الرمز.",
  "landing.chip.install": "لا شيء يُثبَّت",
  "landing.chip.browser": "يعمل في أي متصفح حديث",
  "landing.chip.guests": "الضيوف يدخلون باسمهم فقط",
  "landing.chip.scale": "حتى 500 شخص، وحتى 20 ساعة",
  "landing.preview.alt":
    "اجتماع جارٍ: أربعة أشخاص في شبكة، وأسفلها أزرار الميكروفون والكاميرا ومشاركة الشاشة واللوح.",
  "landing.features.title": "كل ما يحتاجه الاجتماع فعلًا",
  "landing.features.body":
    "ليست حزمة ضخمة. الأشياء القليلة التي تفعلها في المكالمة، مصنوعة كما ينبغي.",
  "landing.swipe": "اسحب للمزيد",
  "landing.how.title": "ثلاث خطوات، بلا إعداد",
  "landing.how.1.title": "ابدأ اجتماعًا",
  "landing.how.1.body":
    "سجّل الدخول واضغط زرًا واحدًا. تُنشأ الغرفة في اللحظة نفسها، برمز يمكن قراءته بصوت عالٍ.",
  "landing.how.2.title": "أرسل الرمز",
  "landing.how.2.body": "ثلاث مجموعات من أربعة أحرف، أو الرابط كاملًا. من يصله يكتب اسمه ويدخل.",
  "landing.how.3.title": "تحدّث واعرض واكتب",
  "landing.how.3.body": "شغّل الكاميرا، شارك شاشتك، اعرض شرائحك واكتبوا عليها معًا وأنتم تتحدثون.",
  "landing.faq.title": "أسئلة تُطرح أولًا",
  "landing.faq.account.q": "هل أحتاج حسابًا؟",
  "landing.faq.account.a":
    "لبدء اجتماع فقط. الانضمام لا يحتاج حسابًا أبدًا: افتح الرابط، اكتب اسمًا، وأنت في الداخل بصوت وصورة كاملين.",
  "landing.faq.limits.q": "كم عدد المشاركين، وكم تطول الجلسة؟",
  "landing.faq.limits.a":
    "حتى 500 شخص في اجتماع واحد، ويمكن أن يستمر الاجتماع الواحد حتى عشرين ساعة. لا شيء ينقطع بعد أربعين دقيقة، ولا عدد مقاعد تراقبه.",
  "landing.faq.install.q": "هل هناك ما يجب تثبيته؟",
  "landing.faq.install.a":
    "لا. يعمل في المتصفح على الهاتف والجهاز اللوحي والحاسوب. وإن أردت أيقونة، يمكن تثبيته على الشاشة الرئيسية كتطبيق.",
  "landing.faq.share.q": "هل يمكنني مشاركة الشاشة وعرض الشرائح؟",
  "landing.faq.share.a":
    "نعم. تُرسل الشاشة المشتركة بدقتها الكاملة دون اقتصاص، ويتحول ملف PDF أو PowerPoint إلى شرائح يستطيع الجميع الكتابة عليها.",
  "landing.faq.record.q": "هل يمكن تسجيل الاجتماعات تلقائيًا؟",
  "landing.faq.record.a":
    "نعم. يستطيع المضيف الضغط على التسجيل في أي اجتماع، أو ضبط الغرفة لتسجّل كل اجتماع فيها منذ لحظة بدايته. ويعرف كل من في الغرفة أن التسجيل جارٍ، ويُشاهَد بعدها في المتصفح.",
  "landing.faq.control.q": "من يستطيع كتم أحدهم أو إخراجه؟",
  "landing.faq.control.a":
    "المضيف، ومن يجعله مضيفًا مشاركًا. هناك غرفة انتظار، وأذونات لكل شخص، وكتم، وإخراج، وإنهاء للجميع يُنهيه فعلًا.",
  "landing.cta.title": "متى ما كنت مستعدًا",
  "landing.cta.body": "ابدأ اجتماعًا الآن، أو انضم إلى واحد برمز وصلك.",
  "landing.integrate.title": "تبني شيئًا فوقه؟",
  "landing.integrate.body":
    "لدى {name} واجهة REST وWebSocket موثّقة، ومفاتيح خدمة لإنشاء الغرف والاجتماعات نيابة عن مستخدميك. هكذا يدمجه BS Chat وBS Calendar.",
  "landing.integrate.link": "اقرأ دليل التكامل",

  "docs.title": "واجهة {name} البرمجية",
  "docs.version": "الإصدار ١",
  "docs.errors": "الأخطاء",
  "docs.event": "الحدث",
  "docs.direction": "الاتجاه",
  "docs.payload": "الحمولة",
  "docs.inbound": "من العميل إلى الخادم",
  "docs.outbound": "من الخادم إلى العميل",
  "docs.body": "الجسم",
  "docs.returns": "يُرجع",
  "docs.note": "ملاحظة",
  "docs.auth.public": "عام",
  "docs.auth.user": "رمز مستخدم",
  "docs.auth.service": "مفتاح خدمة",

  "auth.welcomeBack": "أهلًا بعودتك",
  "auth.signInSubtitle": "سجّل الدخول لبدء الاجتماعات وجدولتها.",
  "auth.createTitle": "أنشئ حسابك",
  "auth.createSubtitle": "الحساب مطلوب للاستضافة فقط. الانضمام لا يحتاجه أبدًا.",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.currentPassword": "كلمة المرور الحالية",
  "auth.newPassword": "كلمة المرور الجديدة",
  "auth.name": "الاسم",
  "auth.displayName": "الاسم المعروض",
  "auth.newHere": "جديد هنا؟",
  "auth.haveAccount": "لديك حساب بالفعل؟",
  "auth.passwordHint": "{count} حرفًا على الأقل",
  "auth.changePassword": "تغيير كلمة المرور",
  "auth.passwordChanged": "تم تغيير كلمة المرور. وسُجّل خروج بقية أجهزتك.",
  "auth.passwordSection": "تغييرها يسجّل الخروج من كل جهاز آخر.",
  "auth.profileSaved": "تم حفظ الملف الشخصي",
  "auth.nameIsShown": "اسمك هو ما يراه الجميع في الاجتماع.",

  "dash.goodMorning": "صباح الخير",
  "dash.goodAfternoon": "مساء الخير",
  "dash.goodEvening": "مساء الخير",
  "dash.greeting": "{greeting}، {name}",
  "dash.subtitle": "ابدأ اجتماعًا الآن، أو خطّط لواحد لاحقًا.",
  "dash.startNow": "ابدأ اجتماعًا",
  "dash.instantTitle": "اجتماع فوري",
  "dash.scheduleLater": "جدولة لوقت لاحق",
  "dash.upcoming": "القادمة",
  "dash.past": "السابقة",
  "dash.scheduledCount": "{count} مجدولة",
  "dash.nothingScheduled": "لا شيء مجدول",
  "dash.nothingScheduledBody": "كل ما تجدوله وكل ما تُدعى إليه يظهر هنا.",
  "dash.loadFailed": "تعذّر تحميل اجتماعاتك. تحقق من اتصالك وحاول مجددًا.",
  "dash.loadingMeetings": "جارٍ تحميل اجتماعاتك",

  "rooms.title": "غرفك",
  "rooms.subtitle": "تحتفظ الغرفة بالرمز نفسه ما دامت موجودة.",
  "rooms.loading": "جارٍ تحميل غرفك",
  "rooms.new": "غرفة جديدة",
  "rooms.created": "تم إنشاء الغرفة",
  "rooms.none": "لا غرف بعد",
  "rooms.noneBody": "أنشئ واحدة لتحصل على رمز تعيد استخدامه لاجتماع متكرر.",
  "rooms.open": "فتح",
  "rooms.copyLink": "نسخ رابط الغرفة",
  "rooms.linkCopied": "تم نسخ رابط الغرفة",
  "rooms.deleteThis": "حذف «{title}»",
  "rooms.deleteTitle": "حذف «{title}»؟",
  "rooms.deleteBody": "سيتوقف رمزها عن العمل، ولن يفتح أي رابط شاركته من قبل شيئًا.",
  "rooms.delete": "حذف الغرفة",
  "rooms.inCall": "{count} في المكالمة",
  "rooms.createdWhen": "أُنشئت {when}",
  "rooms.capacity": "حتى {count}",
  "rooms.noHistory": "لم يُعقد أي اجتماع في هذه الغرفة بعد.",
  "rooms.flag.lobby": "غرفة الانتظار",
  "rooms.flag.signedInOnly": "يلزم تسجيل الدخول",
  "rooms.flag.hostFirst": "المضيف أولاً",
  "rooms.flag.noRecording": "التسجيل موقوف",
  "rooms.flag.noChat": "الدردشة موقوفة",
  "rooms.stat.meetings": "الاجتماعات",
  "rooms.stat.joins": "مرات الانضمام",
  "rooms.stat.joinsHint": "{people} بحساب؛ من انضم مرة أخرى يُحسب من جديد.",
  "rooms.stat.peak": "أكثر عدد معاً",
  "rooms.stat.totalTime": "الوقت الإجمالي",
  "rooms.stat.longestHint": "أطول اجتماع: {duration}",
  "rooms.stat.messages": "رسائل الدردشة",
  "rooms.stat.recordings": "التسجيلات",
  "rooms.stat.lastMeeting": "آخر اجتماع",

  "schedule.title": "جدولة اجتماع",
  "schedule.editTitle": "تعديل الاجتماع",
  "schedule.titleField": "العنوان",
  "schedule.titlePlaceholder": "اللقاء الأسبوعي",
  "schedule.starts": "يبدأ",
  "schedule.ends": "ينتهي",
  "schedule.repeat": "التكرار",
  "schedule.repeatNone": "لا يتكرر",
  "schedule.repeatDaily": "كل يوم",
  "schedule.repeatWeekly": "كل أسبوع",
  "schedule.repeatTwoWeeks": "كل أسبوعين",
  "schedule.repeatThreeWeeks": "كل ثلاثة أسابيع",
  "schedule.repeatMonthly": "كل شهر",
  "schedule.repeatTwoMonths": "كل شهرين",
  "schedule.repeatThreeMonths": "كل ثلاثة أشهر",
  "schedule.timezoneHint": "الأوقات أعلاه تُقرأ بهذه المنطقة. ويراها الآخرون بتوقيتهم.",
  "schedule.description": "الوصف",
  "schedule.descriptionPlaceholder": "جدول الأعمال، الروابط، وكل ما يُقرأ مسبقًا.",
  "schedule.inviteByEmail": "دعوة بالبريد الإلكتروني",
  "schedule.inviteHint":
    "اكتب العناوين أو الصقها. المسافة أو الفاصلة أو الفاصلة المنقوطة تفصل بينها.",
  "schedule.emailsPlaceholder": "sara@example.com، ali@example.com",
  "schedule.submit": "جدولة",
  "schedule.saved": "تم تحديث الاجتماع",
  "schedule.created": "تمت جدولة الاجتماع",
  "schedule.cancelTitle": "إلغاء «{title}»؟",
  "schedule.cancelBody": "سيُبلَّغ كل المدعوين بأن الاجتماع أُلغي.",
  "schedule.cancelAction": "إلغاء الاجتماع",
  "schedule.cancelKeep": "الإبقاء عليه",
  "schedule.cancelled": "أُلغي الاجتماع",

  "meeting.liveNow": "جارٍ الآن",
  "meeting.cancelled": "ملغى",
  "meeting.repeats": "متكرر",
  "meeting.fromService": "من {service}",
  "meeting.accepted": "قبل {accepted} من {total}",
  "meeting.copyJoinLink": "نسخ رابط الانضمام",
  "meeting.invitePeople": "دعوة أشخاص",
  "meeting.cancelThis": "إلغاء هذا الاجتماع",
  "meeting.linkCopied": "تم نسخ رابط الاجتماع",

  "invite.title": "دعوة أشخاص",
  "invite.anyoneWithLink": "أي شخص يملك الرابط",
  "invite.copyLink": "نسخ الرابط",
  "invite.send": "إرسال الدعوات",
  "invite.sent": "تمت دعوة {count}",
  "invite.invitedCount": "المدعوون ({count})",
  "invite.copyPersonal": "نسخ الرابط الخاص بـ {email}",
  "invite.remove": "إزالة {email}",
  "invite.personalCopied": "تم نسخ الرابط الخاص",
  "invite.status.pending": "قيد الانتظار",
  "invite.status.accepted": "مقبولة",
  "invite.status.declined": "مرفوضة",
  "invite.accept": "قبول",
  "invite.decline": "رفض",
  "invite.invitedYou": "دعاك {name}",
  "invite.joinNow": "انضم إلى الاجتماع الآن",
  "invite.answered": "لقد {status} هذه الدعوة.",
  "invite.notFound": "الدعوة غير موجودة",
  "invite.notFoundBody": "لم يعد رابط الدعوة صالحًا. اطلب من المنظّم إرسال رابط جديد.",
  "invite.opening": "جارٍ فتح دعوتك",
  "invite.seeYouThere": "إلى اللقاء هناك",
  "invite.organizerTold": "تم إبلاغ المنظّم",

  "prejoin.joinNow": "انضم الآن",
  "prejoin.askToJoin": "اطلب الانضمام",
  "prejoin.yourName": "اسمك",
  "prejoin.namePlaceholder": "بماذا يناديك الناس؟",
  "prejoin.joiningAs": "تنضم باسم {name}",
  "prejoin.hostedBy": "يستضيفه {name}",
  "prejoin.alreadyHere": "{count} موجودون بالفعل",
  "prejoin.cameraOff": "الكاميرا مغلقة",
  "prejoin.lobbyNote": "لهذا الاجتماع غرفة انتظار، فعلى المضيف أن يُدخلك.",
  "prejoin.joinMuted": "الانضمام مع كتم الصوت",
  "prejoin.joinUnmuted": "الانضمام مع فتح الميكروفون",
  "prejoin.joinCameraOff": "الانضمام مع إغلاق الكاميرا",
  "prejoin.joinCameraOn": "الانضمام مع فتح الكاميرا",

  "call.meeting": "اجتماع",
  "call.connecting": "جارٍ الاتصال",
  "call.reconnecting": "انقطع الاتصال. جارٍ إعادتك.",
  "call.participantAway": "جارٍ إعادة الاتصال",
  "call.offline": "لا يوجد اتصال بالإنترنت.",
  "call.retryNow": "أعد المحاولة الآن",
  "call.joiningSlow": "هذا يستغرق أطول من المعتاد",
  "call.joiningSlowBody": "الاجتماع لم يستجب بعد. المحاولة مستمرة، ويمكنك إعادتها الآن.",
  "call.backInTheRoom": "عدت إلى الاجتماع",
  "call.meetingElapsed": "مدة الاجتماع",
  "call.joinedElapsed": "منذ انضمامك",
  "call.joining": "جارٍ الانضمام إلى الاجتماع",
  "call.finding": "جارٍ البحث عن الاجتماع",
  "call.tapToHear": "اضغط لسماع المكالمة",
  "call.recording": "جارٍ التسجيل",
  "call.copyLink": "نسخ رابط الاجتماع",
  "call.zoomIn": "تكبير",
  "call.zoomOut": "تصغير",
  "call.zoomReset": "ملء الإطار",
  "call.fullScreen": "ملء الشاشة",
  "call.exitFullScreen": "إنهاء ملء الشاشة",
  "call.settings": "إعدادات الاجتماع",
  "call.startRecording": "بدء التسجيل",
  "call.stopRecording": "إيقاف التسجيل",
  "call.fullscreen": "ملء الشاشة",
  "call.exitFullscreen": "الخروج من ملء الشاشة",
  "call.mediaTrouble": "مشكلة في اتصال الصوت والصورة",
  "call.noMediaServer": "لا يملك هذا الخادم خادم وسائط، فالصوت والصورة مغلقان",
  "call.noMediaServerBody":
    "تعمل الدردشة واللوح الأبيض وبقية مزايا الاجتماع. كاميرتك تظهر لك وحدك.",
  "call.mute": "كتم الميكروفون",
  "call.unmute": "فتح الميكروفون",
  "call.cameraOn": "تشغيل الكاميرا",
  "call.micNotAllowed": "أوقف المضيف الميكروفون لديك",
  "call.camNotAllowed": "أوقف المضيف الكاميرا لديك",
  "call.cameraOff": "إيقاف الكاميرا",
  "call.share": "مشاركة شاشتك",
  "call.youAreSharing": "أنت من يشارك هذه الشاشة",
  "call.stopShare": "إيقاف مشاركة الشاشة",
  "call.raiseHand": "ارفع يدك",
  "call.lowerHand": "أنزل يدك",
  "call.leave": "مغادرة الاجتماع",
  "call.leaveOrEnd": "المغادرة أم إنهاء الاجتماع؟",
  "call.leaveOrEndBody":
    "{count} آخرون ما زالوا هنا. إن غادرت استمر الاجتماع من دونك، وإن أنهيته خرج الجميع منه.",
  "call.leaveOrEndBody#one":
    "شخص واحد آخر ما زال هنا. إن غادرت استمر الاجتماع من دونك، وإن أنهيته خرج الجميع منه.",
  "call.leaveOrEndBody#two":
    "شخصان آخران ما زالا هنا. إن غادرت استمر الاجتماع من دونك، وإن أنهيته خرج الجميع منه.",
  "call.leaveOrEndBody#few":
    "{count} أشخاص آخرون ما زالوا هنا. إن غادرت استمر الاجتماع من دونك، وإن أنهيته خرج الجميع منه.",
  "call.justLeave": "مغادرة فقط",
  "call.endForEveryone": "إنهاء للجميع",
  "call.people": "الأشخاص",
  "call.chat": "الدردشة",
  "call.present": "اللوح",
  "call.settingsTitle": "الإعدادات",
  "call.audioVideo": "الصوت والصورة",
  "call.switchCamera": "التبديل إلى {camera}",
  "call.switchOutput": "تشغيل الصوت عبر {device}",
  "call.moreOptions": "خيارات أخرى",
  "call.closePanel": "إغلاق اللوحة",
  "call.waitingForOthers": "في انتظار انضمام الآخرين.",
  "call.pin": "تثبيت في العرض الرئيسي",
  "call.unpin": "إلغاء التثبيت",
  "call.host": "المضيف",
  "call.waitingToBeLetIn": "في انتظار الإدخال",
  "call.waitingBody": "على المضيف أن يُدخلك. تتحدّث هذه الصفحة تلقائيًا حين يفعل.",
  "call.ended": "انتهى الاجتماع",
  "call.removedByHost": "قام المضيف بإزالتك من الاجتماع",
  "call.notIn": "أنت لست في الاجتماع",
  "call.youLeft": "لقد غادرت الاجتماع.",
  "call.rejoin": "الانضمام مجددًا",
  "call.backToMeetings": "العودة إلى الاجتماعات",
  "call.backToWhereYouCameFrom": "العودة إلى حيث أتيت",
  "call.notFound": "تعذّر العثور على هذا الاجتماع",
  "call.notFoundBody": "تحقق من الرمز، أو اطلب رابطًا جديدًا ممن دعاك.",
  "call.speakingWhileMuted": "أنت تتحدث، لكن الميكروفون لديك مغلق",
  "call.mutedByHost": "كتم المضيف صوتك",
  "call.someoneCouldNotBeHeard": "تعذّر سماع أو رؤية بعض المشاركين",

  "people.inMeeting": "في الاجتماع ({count})",
  "people.waiting": "في انتظار الانضمام ({count})",
  "people.admit": "إدخال {name}",
  "people.deny": "رفض {name}",
  "people.muteEveryone": "كتم الجميع",
  "people.mutedEveryoneResult": "تم كتم صوت {count} شخص",
  "people.mutedNobody": "الجميع صامت بالفعل",
  "people.options": "خيارات {name}",
  "people.mute": "كتم",
  "people.makeRole": "تعيينه {role}",
  "people.remove": "إزالة من الاجتماع",
  "people.lobbyOn": "غرفة الانتظار مفعّلة",
  "people.giveControl": "أعطه العرض",
  "people.presenting": "يقدّم الآن",
  "people.allowedTo": "مسموح له",
  "grant.mic": "استخدام الميكروفون",
  "grant.cam": "استخدام الكاميرا",
  "grant.share": "مشاركة الشاشة",
  "grant.draw": "الرسم على الشرائح",
  "grant.upload": "إضافة شرائح جديدة",
  "board.takeControl": "تولّي العرض",
  "board.someoneElsePresenting": "{name} يقدّم الآن",
  "board.youArePresenting": "أنت تقدّم الآن",
  "role.host": "مضيف",
  "role.cohost": "مضيف مشارك",
  "role.presenter": "مقدّم",
  "role.guest": "ضيف",

  "chat.placeholder": "أرسل رسالة",
  "chat.send": "إرسال",
  "chat.message": "رسالة",
  "chat.empty": "الرسائل هنا يراها كل من في الاجتماع ولا يُحتفظ بها بعده.",
  "chat.whisperFrom": "{name} همس إليك: {body}",
  "chat.whisperTo": "رسالة خاصة إلى {name}",
  "chat.privateTo": "خاصة إلى {name}",
  "chat.privateFrom": "خاصة",
  "chat.toEveryone": "الجميع",
  "chat.recipient": "إرسال إلى",
  "chat.whisperPlaceholder": "رسالة خاصة إلى {name}",
  "chat.whisperNote": "لن يراها إلا {name}.",

  "board.present": "العرض",

  "board.tools": "أدوات الرسم",
  "board.presentBody": "يرى الجميع الصفحة نفسها، ويستطيع كل من يملك حق العرض أن يرسم عليها.",
  "board.uploadDocument": "ارفع ملف PDF أو PowerPoint",
  "board.uploadImages": "ارفع صورًا كشرائح",
  "board.blank": "لوح أبيض فارغ",
  "board.notAllowed": "لم يمنحك المضيف إذن إضافة شرائح في هذا الاجتماع.",
  "board.uploading": "جارٍ الرفع {percent}٪",
  "board.checking": "يجري التحقق مما إذا كان هذا الملف موجودًا هنا بالفعل",
  "board.alreadyHere": "{title} موجود في هذا الاجتماع بالفعل، لذا يُفتح دون رفعه من جديد",
  "board.noConversion":
    "تحويل المستندات غير مُهيّأ على هذا الخادم، فرفع PDF وPowerPoint غير متاح. الصور واللوح الفارغ يعملان.",
  "board.limits": "حتى {size} و{pages} صفحة لكل مستند.",
  "board.presenting": "يعرض {title}، الصفحة {page} من {total}.",
  "board.tooLarge": "حجم «{file}» هو {size}، وهو أكبر من حد {limit}",
  "board.fileEmpty": "«{file}» فارغ، فلا يوجد ما يمكن عرضه",
  "board.fileUnsupported": "«{file}» ليس من الأنواع التي يمكن عرضها",
  "board.tooManyPages": "اخترت {count} صورة، والحد الأقصى للعرض التقديمي هو {limit} صفحة",
  "board.preparing": "جارٍ تجهيز الشرائح",
  "board.preparingProgress": "جارٍ تجهيز الشرائح ({page} من {total})",
  "board.previousPage": "الصفحة السابقة",
  "board.nextPage": "الصفحة التالية",
  "board.zoomIn": "تكبير",
  "board.zoomOut": "تصغير",
  "board.zoomPercent": "٪{percent}",
  "board.fitScreen": "عرض الصفحة كاملة",
  "board.fullWidth": "بعرض الشاشة",
  "board.pan": "تحريك الصفحة",
  "board.stopPresenting": "إيقاف العرض",
  "board.undo": "تراجع عن آخر خط",
  "board.clearPage": "مسح هذه الصفحة للجميع",
  "board.textPrompt": "النص المراد إضافته",
  "board.textPromptBody": "يوضع حيث نقرت، ويراه كل من في الاجتماع.",
  "board.textPlaceholder": "اكتب النص",
  "board.addText": "إضافة نص",
  "board.colour": "اللون {colour}",
  "board.thickness": "السماكة {size}",
  "board.palette": "الألوان",
  "board.moreColours": "ألوان أخرى، {colour} محدد",
  "board.customColour": "مخصص",
  "colour.red": "أحمر",
  "colour.orange": "برتقالي",
  "colour.amber": "كهرماني",
  "colour.yellow": "أصفر",
  "colour.lime": "ليموني",
  "colour.green": "أخضر",
  "colour.emerald": "زمردي",
  "colour.teal": "أزرق مخضر",
  "colour.cyan": "سماوي",
  "colour.sky": "أزرق سماوي",
  "colour.blue": "أزرق",
  "colour.indigo": "نيلي",
  "colour.violet": "بنفسجي",
  "colour.purple": "أرجواني",
  "colour.fuchsia": "فوشيا",
  "colour.pink": "زهري",
  "colour.rose": "وردي",
  "colour.brown": "بني",
  "colour.slate": "رمادي",
  "colour.ink": "أسود",
  "colour.white": "أبيض",
  "tool.pen": "قلم",
  "tool.highlighter": "تظليل",
  "tool.line": "خط",
  "tool.arrow": "سهم",
  "tool.rect": "مستطيل",
  "tool.ellipse": "بيضاوي",
  "tool.text": "نص",
  "tool.eraser": "ممحاة",

  "device.microphone": "الميكروفون",
  "device.camera": "الكاميرا",
  "device.speakers": "السماعات",
  "effect.background": "الخلفية",
  "effect.none": "إيقاف",
  "effect.blur": "ضبابية",
  "effect.blurStrong": "ضبابية قوية",
  "effect.hint":
    "يرى الجميع في الاجتماع التأثير نفسه، وليس أنت وحدك. تجري المعالجة على هذا الجهاز ولا يغادره شيء.",
  "effect.unsupported": "هذا المتصفح لا يستطيع تشغيل تأثيرات الخلفية.",
  "device.noOutputPicker":
    "لا يسمح هذا المتصفح للصفحة باختيار جهاز الإخراج. غيّره من إعدادات النظام.",
  "device.namesAfterPermission":
    "تظهر أسماء الأجهزة بعد السماح بالوصول إلى الكاميرا أو الميكروفون.",

  "mic.title": "الميكروفون",
  "mic.settingsBody": "كيف يسمعك الآخرون. ينطبق على كل اجتماع تنضم إليه من هذا المتصفح.",
  "mic.level": "مستوى الإدخال",
  "mic.levelBody": "قل شيئًا. يتبع الشريط ما يلتقطه الميكروفون، قبل إرسال أي شيء.",
  "mic.levelOff": "شغّل الميكروفون لترى ما يلتقطه.",
  "mic.noiseSuppression": "كتم الضوضاء",
  "mic.noiseSuppressionBody":
    "يزيل صوت المروحة ولوحة المفاتيح وطنين الغرفة. اتركه مشغّلًا ما لم يكن لديك سبب.",
  "mic.echoCancellation": "إلغاء الصدى",
  "mic.echoCancellationBody":
    "يمنع عودة ما تشغّله سماعاتك إلى الاجتماع كصدى. أوقفه فقط عندما ترتدي سماعة رأس.",
  "mic.autoGain": "ضبط المستوى تلقائيًا",
  "mic.autoGainBody": "يترك للمتصفح موازنة علو صوتك وأنت تقترب من الميكروفون وتبتعد عنه.",
  "mic.noBrowserProcessing": "لا يسمح هذا المتصفح للصفحة بتغيير معالجة الميكروفون.",
  "mic.quality": "جودة الصوت",
  "mic.qualitySpeech": "الكلام",
  "mic.qualitySpeechBody":
    "صوت واحد في كل مرة، ولا يُرسل شيء في الصمت بين الجمل. الخيار الصحيح للاجتماع.",
  "mic.qualityClear": "كلام أوضح",
  "mic.qualityClearBody": "ضعف معدل البت، لصوت على اتصال يحتمل ذلك.",
  "mic.qualityMusic": "موسيقى",
  "mic.qualityMusicBody":
    "كلتا القناتين، وأربعة أضعاف معدل البت، ولا قطع بين العبارات. لآلة أو تسجيل، لا للحديث.",
  "mic.volume": "مستوى الميكروفون",
  "mic.clarity": "الوضوح",
  "mic.clarityBody":
    "يرفع الوضوح الجزء الذي يحمل الحروف الساكنة من الصوت ويخفض الهدير تحته، وهو ما يجعل متابعة المتحدث الهادئ أسهل.",
  "mic.gate": "بوابة الضوضاء",
  "mic.gateOff": "إيقاف",
  "mic.gateBody":
    "تغلق البوابة الميكروفون تمامًا تحت المستوى المعلّم على الشريط، فلا ترسل غرفة لا يتحدث فيها أحد شيئًا. ارفعها حتى تقف العلامة فوق ضجيج غرفتك وتحت صوتك.",
  "mic.percent": "{value}٪",
  "mic.volumeMin": "الأدنى",
  "mic.volumeMax": "الأعلى",
  "mic.clarityMin": "إيقاف",
  "mic.clarityMax": "الأقصى",
  "mic.gateMax": "الأشد",
  "mic.reset": "إعادة إلى الوضع الافتراضي",

  "voice.title": "الصوت",
  "voice.none": "عادي",
  "voice.woman": "أنثى",
  "voice.man": "ذكر",
  "voice.chipmunk": "سنجاب",
  "voice.giant": "عملاق",
  "voice.robot": "روبوت",
  "voice.alien": "كائن فضائي",
  "voice.custom": "مخصص",
  "voice.hint":
    "يسمع الجميع في الاجتماع الصوت الذي تختاره، لا صوتك أنت. يجري ذلك على هذا الجهاز ولا يُرسَل شيء إضافي.",
  "voice.listen": "أسمع نفسي",
  "voice.stopListening": "إيقاف",
  "voice.listenBody": "ضع السماعات أولاً، وإلا سمعت الغرفة نفسها.",
  "voice.unsupported": "لا يستطيع هذا المتصفح تغيير الصوت.",
  "voice.pitch": "طبقة الصوت",
  "voice.pitchMin": "أعمق",
  "voice.pitchMax": "أعلى",
  "voice.semitones": "{value} نصف درجة",
  "voice.noShift": "بلا تغيير",
  "voice.formant": "حجم الصوت",
  "voice.formantMin": "أكبر",
  "voice.formantMax": "أصغر",
  "voice.customBody":
    "طبقة الصوت هي النغمة التي تتحدث بها. وحجم الصوت هو مدى اتساع الحلق الذي خلفها، وتحريك الاثنين معًا هو ما يجعل الصوت المختلف مقنعًا لا مجرد حاد أو غليظ.",

  "sound.title": "الأصوات",
  "sound.cues": "المؤثرات الصوتية",
  "sound.cuesBody": "نغمة قصيرة عند دخول أحدهم أو خروجه أو رفع يده أو إرسال رسالة.",
  "sound.speech": "الإعلانات المنطوقة",
  "sound.speechBody": "تقول ما حدث بصوت مسموع، وبلغة هذه الصفحة.",
  "sound.settingsBody": "ينطبق على كل اجتماع تنضم إليه من هذا المتصفح.",
  "sound.volume": "مستوى الصوت",
  "sound.test": "تجربة",
  "sound.percent": "{value}٪",
  "sound.volumeMin": "صامت",
  "sound.volumeMax": "الأعلى",
  "sound.noVoice": "لا يملك هذا المتصفح صوتًا بـ{language}، لذا لن يُقال شيء بصوت مسموع.",
  "sound.joined": "انضم {name}",
  "sound.joinedMany": "انضم {count} أشخاص",
  "sound.left": "غادر {name}",
  "sound.leftMany": "غادر {count} أشخاص",
  "sound.knocking": "{name} في انتظار الإذن بالدخول",
  "sound.knockingMany": "{count} أشخاص في انتظار الإذن بالدخول",
  "sound.admitted": "أنت الآن في الاجتماع",
  "sound.chatMessage": "رسالة من {name}",
  "sound.chatMessageMany": "{count} رسائل جديدة",
  "sound.handRaised": "رفع {name} يده",
  "sound.recordingOn": "بدأ التسجيل",
  "sound.recordingOff": "توقف التسجيل",
  "sound.speakingWhileMuted": "الميكروفون لديك مغلق",
  "sound.grantedMic": "يمكنك استخدام الميكروفون",
  "sound.revokedMic": "لم يعد بإمكانك استخدام الميكروفون",
  "sound.grantedCam": "يمكنك استخدام الكاميرا",
  "sound.revokedCam": "لم يعد بإمكانك استخدام الكاميرا",
  "sound.grantedShare": "يمكنك مشاركة شاشتك",
  "sound.revokedShare": "لم يعد بإمكانك مشاركة شاشتك",
  "sound.grantedDraw": "يمكنك الرسم على الشرائح",
  "sound.revokedDraw": "لم يعد بإمكانك الرسم على الشرائح",
  "sound.grantedUpload": "يمكنك عرض شرائح جديدة",
  "sound.revokedUpload": "لم يعد بإمكانك عرض شرائح جديدة",
  "sound.permissionsChanged": "تغيّر ما يُسمح لك به",
  "sound.nowHost": "أنت المضيف الآن",
  "sound.nowCohost": "أنت مضيف مشارك الآن",
  "sound.nowPresenter": "يمكنك العرض الآن",
  "sound.nowGuest": "أنت ضيف الآن",
  "sound.mutedByHost": "كتم المضيف صوتك",
  "sound.screenOn": "{name} يشارك شاشته",
  "sound.screenOff": "أوقف {name} المشاركة",
  "sound.presenting": "يجري الآن عرض {title}",
  "sound.reconnecting": "انقطع الاتصال. جارٍ إعادة الاتصال",
  "sound.reconnected": "عدت إلى الاجتماع",
  "sound.ended": "انتهى الاجتماع",

  "recordings.show": "التسجيلات",
  "recordings.showCount": "التسجيلات ({count})",
  "recordings.startedBy": "بدأه {name}",
  "recordings.none": "لا تسجيلات لهذه الغرفة بعد.",
  "recordings.inProgress": "يجري التسجيل",
  "recordings.copyLink": "نسخ الرابط",
  "recordings.linkCopied": "نُسخ الرابط. من يملكه يستطيع مشاهدة التسجيل.",
  "recordings.watch": "مشاهدة",
  "playback.loading": "جارٍ فتح التسجيل",
  "playback.missing": "هذا التسجيل غير موجود",
  "playback.missingBody":
    "قد يكون الرابط خاطئًا أو حُذف التسجيل. لا يمكن الوصول إلى التسجيلات إلا عبر الرابط نفسه الذي شورك به.",
  "playback.unavailable": "تعذّر تحميل التسجيل",
  "playback.unavailableBody": "حدث خطأ أثناء الوصول إلى الخادم. حاول بعد قليل.",
  "playback.recordedBy": "سجّله {name}",
  "playback.noBoard": "لم يكن يُعرض شيء في هذه اللحظة",
  "playback.chat": "الدردشة",
  "playback.noChat": "لم يُقل شيء حتى هذه اللحظة.",
  "playback.play": "تشغيل",
  "playback.pause": "إيقاف مؤقت",
  "playback.seek": "الموضع في التسجيل",
  "playback.micOn": "الميكروفون يعمل",
  "playback.micOff": "الميكروفون متوقف",
  "playback.camOn": "الكاميرا تعمل",
  "playback.camOff": "الكاميرا متوقفة",

  "settings.lobby": "غرفة الانتظار",
  "settings.lobbyBody": "ينتظر الناس حتى يُدخلهم المضيف.",
  "settings.allowGuests": "السماح للضيوف",
  "settings.allowGuestsBody": "من يملك الرابط ينضم بكتابة اسم.",
  "settings.muteOnEntry": "كتم عند الدخول",
  "settings.muteOnEntryBody": "يدخل الجميع مكتومين.",
  "settings.shareLink": "إظهار رابط الانضمام",
  "settings.shareLinkBody": "رمز الغرفة وزر النسخ في رأس الاجتماع.",
  "settings.allowScreenShare": "السماح بمشاركة الشاشة",
  "settings.allowBoard": "السماح بالعرض",
  "settings.allowBoardBody": "الشرائح واللوح الأبيض.",
  "settings.allowChat": "السماح بالدردشة",
  "settings.allowWhisper": "السماح بالرسائل الخاصة",
  "settings.allowWhisperBody":
    "يمكن للمشاركين مراسلة شخص واحد في الاجتماع بدلاً من الجميع. أوقف هذا في اجتماع يجب أن يُقال فيه كل شيء أمام الجميع.",
  "settings.allowRecording": "السماح بالتسجيل",
  "settings.allowRecordingBody":
    "يمكن للمضيف تسجيل الاجتماع. ويُعلَم كل من في الغرفة ما دام التسجيل جاريًا.",
  "settings.autoRecord": "تسجيل كل اجتماع",
  "settings.autoRecordBody":
    "يبدأ التسجيل مع بداية الاجتماع دون أن يتذكره أحد، ويستطيع أي مشرف إيقافه.",
  "settings.tabDevices": "الصوت والفيديو",
  "settings.tabMeeting": "الاجتماع",
  "settings.tabGuests": "الضيوف",
  "settings.pageSubtitle": "ملفك الشخصي وكلمة مرورك وكيف يكون صوت الاجتماعات قبل انضمامك.",
  "settings.memberSince": "عضو منذ {date}",
  "settings.groupAccount": "الحساب",
  "settings.groupAudio": "الصوت",
  "settings.sections": "أقسام الإعدادات",
  "settings.groupEntry": "الدخول",
  "settings.groupDuring": "أثناء الاجتماع",
  "settings.groupRecording": "التسجيل",
  "settings.guestDefaults": "ما يستطيع الضيوف فعله",
  "settings.guestDefaultsBody":
    "ينطبق على من ينضم كضيف. ومن ترقّيه أو تمنحه إذنًا بمفرده يحتفظ بما أعطيته.",
  "settings.hostOnly": "المضيف وحده يستطيع تغيير هذه.",
  "settings.endForEveryone": "إنهاء الاجتماع للجميع",

  "settings.stage": "التخطيط",
  "settings.stageBody": "كيف يُرتَّب هذا الاجتماع لكل من فيه.",
  "settings.autoJoin": "ادخل مباشرة",
  "settings.autoJoinBody":
    "بلا شاشة الكاميرا والميكروفون أولًا. للاجتماعات التي يُرسَل الناس إليها من مكان آخر وقد اختاروا الانضمام سلفًا.",
  "settings.cameraOffOnEntry": "الكاميرا مغلقة عند الدخول",
  "settings.cameraOffOnEntryBody": "يدخل الجميع وكاميراتهم مغلقة.",

  "stage.standard": "اجتماع",
  "stage.standardBody": "الجميع في شبكة واحدة، مع شريط الأدوات الكامل واللوحات بجانبه.",
  "stage.telegram": "حديث",
  "stage.telegramBody": "الكاميرات في شريط بالأعلى، والبقية في قائمة تحته، وميكروفون واحد كبير.",

  "talk.participants": "{count} مشاركًا",

  "talk.participants#one": "مشارك واحد",
  "talk.participants#two": "مشاركان",
  "talk.participants#few": "{count} مشاركين",
  "talk.listening": "يستمع",
  "talk.speaking": "يتحدث",
  "talk.muted": "مكتوم",
  "talk.wantsToSpeak": "يريد التحدث",
  "talk.sharing": "يشارك شاشته",
  "talk.youAreLive": "صوتك مسموع",
  "talk.unmute": "إلغاء الكتم",
  "talk.video": "الكاميرا",
  "talk.leave": "مغادرة",
  "talk.putAway": "إخفاء المكالمة",
  "talk.askToSpeak": "اطلب التحدث",
  "talk.cancelAsk": "لا بأس",
  "talk.letThemSpeak": "اسمح لـ {name} بالتحدث",
  "talk.muteThem": "اكتم {name}",
  "talk.noCameras": "لا أحد يشغّل كاميرته.",

  "lobby.knocking": "طُلب من {name} أن يأذن لك بالدخول.",
  "lobby.stillWaiting": "ما زلت تنتظر. ربما لم يره بعد.",
  "lobby.notYetLive": "لا أحد يسمعك أو يراك بعد",

  "error.unauthorized": "يرجى تسجيل الدخول مجددًا.",
  "error.forbidden": "لا يُسمح لك بذلك.",
  "error.not_found": "تعذّر العثور على ذلك.",
  "error.bad_credentials": "البريد وكلمة المرور غير متطابقين.",
  "error.email_taken": "لهذا العنوان حساب بالفعل.",
  "error.registration_closed": "لا يقبل هذا الخادم حسابات جديدة.",
  "error.session_revoked": "أخرجناك لأن تسجيل الدخول هذا استُعمل مرتين. سجّل الدخول من جديد.",
  "error.session_expired": "انتهت جلستك. يرجى تسجيل الدخول مجددًا.",
  "error.crashTitle": "حدث خطأ ما",
  "error.crashBody":
    "توقفت هذه الصفحة عن الاستجابة. إعادة التحميل تحل المشكلة عادة، ويمكنك العودة إلى الاجتماع من الرابط نفسه.",
  "error.crashReload": "إعادة التحميل",
  "error.room_full": "هذا الاجتماع ممتلئ.",
  "error.guests_not_allowed": "هذا الاجتماع مفتوح لمن سجّلوا الدخول فقط.",
  "error.host_absent": "لم يبدأ الاجتماع بعد.",
  "error.meeting_cancelled": "تم إلغاء هذا الاجتماع.",
  "error.bad_passcode": "رمز المرور غير صحيح.",
  "error.bad_code": "هذا ليس رمز اجتماع صحيحًا.",
  "error.already_sharing": "شخص آخر يشارك شاشته بالفعل.",
  "error.no_media_server": "لا يملك هذا الخادم خادم وسائط، فالصوت والصورة غير متاحين.",
  "error.media_denied":
    "رفض المتصفح الوصول إلى الكاميرا أو الميكروفون. اسمح به من شريط العنوان وحاول مرة أخرى.",
  "error.media_missing": "لم يُعثر على كاميرا أو ميكروفون من هذا النوع.",
  "error.media_busy": "يستخدم تطبيق آخر هذا الجهاز.",
  "error.media_unsupported": "هذا المتصفح لا يستطيع فعل ذلك.",
  "error.media_unknown": "تعذّر فتح هذا الجهاز.",
  "error.recording_disabled": "هذا الخادم لا يسجّل الاجتماعات.",
  "error.already_joined": "أنت في هذا الاجتماع بالفعل.",
  "error.no_board": "لا يُعرض شيء الآن.",
  "error.not_presenting": "شخص آخر يعرض الآن.",
  "error.record_failed": "تعذّر بدء التسجيل.",
  "error.too_long": "هذا أكبر من أن يُرسل.",
  "error.media_error": "تعذّر الوصول إلى خادم الوسائط.",
  "error.conversion_unavailable": "لا يستطيع هذا الخادم تحويل المستندات. ارفع صورًا بدلًا من ذلك.",
  "error.too_large": "هذا الملف أكبر مما يسمح به الخادم.",
  "error.unsupported_type": "لا يمكن عرض هذا النوع من الملفات.",
  "error.too_many_rooms": "بلغت الحد الأقصى للغرف. احذف واحدة أولًا.",
  "error.network_error": "تعذّر الوصول إلى الخادم.",
  "error.unavailable": "الخادم غير متاح مؤقتًا.",
  "error.timeout": "لم يستجب الخادم في الوقت المناسب.",
  "error.disconnected": "انقطع الاتصال بالاجتماع.",

  "notFound.title": "غير موجود",
  "notFound.body": "الصفحة التي تبحث عنها غير موجودة.",
  "notFound.home": "اذهب إلى الصفحة الرئيسية",

  "schedule.timezone": "المنطقة الزمنية",
  "schedule.endsBeforeStart": "يجب أن تكون النهاية بعد البداية.",
  "calendar.previousMonth": "الشهر السابق",
  "calendar.nextMonth": "الشهر التالي",
  "calendar.today": "اليوم",
  "emails.remove": "إزالة {email}",
  "emails.notAddresses": "ليس عنوان بريد إلكتروني: {list}",
  "meeting.inZone": "{time} بتوقيت {zone}",
};
